<template>
  <el-card>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ getNameSidebar }}</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <div class="loading" v-loading="loading" v-if="loading"></div>
    <template v-else>
      <app-table-paginate
        :routeEdit="routeEdit"
        :tableQuery="tableQuery"
        :tableColumns="headers"
        :search="true"
      >
        <template v-slot:cutom_button>
          <el-button type="primary" size="medium" @click="nuevoRegistro()">
            Nuevo
            <i class="el-icon-circle-plus-outline el-icon-right"></i>
          </el-button>
        </template>
      </app-table-paginate>
      <br />
    </template>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import pluralize from "pluralize";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";

export default {
  name: "List",
  components: {
    "app-table-paginate": tablaConPaginador,
  },
  computed: {
    ...mapGetters(["getNameSidebar"]),
  },
  created() {
    this.routeEdit =
      "/dashboard/" +
      this.$route.params.db +
      "/form/edit/" +
      this.$route.params.table +
      "/";
    this.init();
    this.$root.$on("delete", (id) => {
      this.loading = true;
      this.eliminarRegistro(id);
    });
  },
  beforeDestroy() {
    this.$root.$off("delete", (id) => {
      this.loading = true;
      this.eliminarRegistro(id);
    });
  },
  data() {
    return {
      loading: true,
      headers: [],
      field: {},
      tableQuery: {},
      nametable: this.$route.params.table,
      relationship: [],
      routeEdit: null,
      deleterow: false,
    };
  },
  watch: {
    $route(to) {
      Object.assign(this.$data, this.$options.data.apply(this));
      // this.loading = true;
      this.tableQuery = {};
      this.headers = [];
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/form/edit/" +
        this.$route.params.table +
        "/";
      // this.init();
      if (this.$route.params.table !== undefined && this.$route.params.id === undefined) {
        this.init();
      }
    },
  },
  methods: {
    async init() {
      await this.getEditTable();

      this.mountTable();
    },
    async getEditTable() {
      const response = await ApiService.post("dashboard/getbread", {
        table: this.$route.params.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      this.field = response.data.data;
    },
    async getListTable() {
      const response = await ApiService.post("dashboard/listtable", {
        table: this.$route.params.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        relationship: this.relationship,
        header: this.headers,
      });
      if (response.data == "Algo ha fallado") {
        this.tableQuery = [];
      } else {
        this.tableQuery = response.data;
        await this.asyncForEach(this.headers, (e, i) => {
          let a = e.prop.split("_");
          if (a[1] == "id") {
            e.prop = pluralize.plural(a[0]);
          }
          return a;
        });
      }

      this.loading = !this.loading;
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    mountTable() {
      let relationship = [this.nametable];
      this.field.forEach((e, i) => {
        if (i != 0) {
          if (e.visibility["thead"]) {
            this.headers.push({
              title: e.name,
              label: e.name,
              path: e.field,
              prop: e.field,
              type: e.type,
              options: e.options,
            });
          }
          if (e.options.length > 0) {
            for (let index = 0; index < e.options.length; index++) {
              if (e.options[index].relationship) {
                let data = {
                  relationship: e.options[index].relationship,
                };
                this.relationship.push(data);
              }
            }
          }
        }
      });

      this.getListTable();
    },
    async eliminarRegistro(id) {
      ApiService.post("dashboard/delete", {
        table: this.$route.params.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id,
      }).then((response) => {
        this.deleterow = response.data;
        setTimeout(() => {
          if (this.deleterow == 1) {
            this.$message({
              type: "success",
              message: "Se ha eliminado correctamente",
            });
            setTimeout(() => {
              this.getListTable();
            }, 200);
          } else {
            this.$message({
              type: "warning",
              message: this.deleterow,
            });
          }
        }, 200);
      });
    },
    nuevoRegistro() {
      this.$router.replace(
        "/dashboard/" + this.$route.params.db + "/form/new/" + this.nametable
      );
    },
  },
};
</script>
<style>
.loading {
  min-height: calc(100vh - 250px);
  background-color: #f5f7fa !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/List.vue